import Step2y1 from './Step2y1'

export default Step2y1